<script>
import { HorizontalBar } from 'vue-chartjs'
import Stacked100 from 'chartjs-plugin-stacked100';


const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export default {
  extends: HorizontalBar,
  props: ['options','height','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: ['Identifiés/Désignés','Non-Identifiés','Total'],
        datasets: [
          {
            label: "Non-débuté",
            data: [this.data.idNonDebute,this.data.niNonDebute,
              this.data.idNonDebute+this.data.niNonDebute],
            fill: true,
            backgroundColor: hex2rgba('#f99a91',0.2),
            borderColor: '#f99a91',
            borderWidth: 1
          },
          {
            label: "En développement",
            data: [this.data.idDevel,this.data.niDevel,
              this.data.idDevel+this.data.niDevel],
            fill: true,
            backgroundColor: hex2rgba('#ecd374',0.2),
            borderColor: '#ecd374',
            borderWidth: 1,
          },
          {
            label: "MaJ/Soumis/Eval/Terminé",
            data: [this.data.idSoumis,this.data.niSoumis,
              this.data.idSoumis+this.data.niSoumis],
            fill: true,
            backgroundColor: hex2rgba('#18b358',0.2),
            borderColor: '#18b358',
            borderWidth: 1,
          },
        ]},
        {
          plugins: { stacked100: { enable: true } },
          responsive: true,
          legend: {
            // display: false
          },
          title: {
            display: true,
            fontSize: 20,
            text: 'Taux de soumission'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            yAxes: [{
              stacked: true
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Pourcentage des FSS'
              },
              stacked: true
            }]
          },
          animation: {
            duration: 500,
          },
        }
      )
    }
  },
  computed: {
  },
  components: {
    Stacked100
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
  }
}
</script>
